

























































































































































































































import {Vue, Component, Watch, Prop, Ref} from 'vue-property-decorator';
import ImportTariffZones from "@/components/Tarification/ImportTariffZones.vue";
import TariffZonesFilter from "@/components/Tarification/TariffZonesFilter.vue";
import {SelectWings, ScrollButton} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {customSort} from '@/utils/data-helper';
import {
  TariffZoneGroupItem,
  TariffZoneItem,
  TarificationTransports,
  TarificationTypes
} from "@/store/tarification/types";

@Component({components: {ImportTariffZones, TariffZonesFilter, ScrollButton, SelectWings}})
export default class TariffZones extends Vue {

  @Ref('importComponent') private importComponent!: ImportTariffZones;
  @Ref('filter') private filter!: TariffZonesFilter;

  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;
  // @Getter("partners") partnersList: any;
  // @Getter("serviceProviders") serviceProvidersList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getTariffZoneGroupItem") actionGetItem: any;
  @Getter("tariffZones") tariffZonesResponse: any;
  @Getter("messageCategories") messageCategoriesList: any;

  @Action("getMessageCategories") actionMessageCategories: any;

  private is_show_filter = false;
  private is_show_import = false;
  private is_exist_tzg = false;
  private currentSort = "name";
  private currentSortOrder = "desc";
  private tableFields = [
    'name',
    'msisdn',
    'mcc',
    'mnc',
    'price',
    'status',
  ];

  private tariffTypeFilter = {
    partner_id: undefined,
    operator_id: undefined,
  }

  private partnerType: TarificationTypes = TarificationTypes.PARTNER
  private operatorType: TarificationTypes = TarificationTypes.OPERATOR
  params = {transport: this.transport};
  partnersList: any = []
  serviceProvidersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, status: 1, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  get tableFieldsActive() {
    if (localStorage.getItem(this.transport.toLowerCase() + this.type + 'TariffZonesTableFields')) {
      let saveData = JSON.parse(localStorage.getItem(this.transport.toLowerCase() + this.type + 'TariffZonesTableFields') || '');
      if (saveData) {
        this.tableFields = saveData;
        return saveData
      }
    }
    return this.tableFields;
  };

  async created() {
    this.actionMessageCategories(this.params);

    if (sessionStorage.getItem(this.transport.toLowerCase() + this.type + 'TariffTypeFilter')) {
      let saveData = JSON.parse(sessionStorage.getItem(this.transport.toLowerCase() + this.type + 'TariffTypeFilter') || '');
      if (saveData) {
        this.tariffTypeFilter = saveData;
        if (this.tariffTypeFilter.partner_id) this.partnersList = await this.actionGetPartners({id: this.tariffTypeFilter.partner_id});
        if (this.tariffTypeFilter.operator_id) this.serviceProvidersList = await this.actionGetServiceProviders({id: this.tariffTypeFilter.operator_id});
      }
    }
  }

  @Watch('tableFields')
  getValue(val: string) {
    localStorage.setItem(this.transport.toLowerCase() + this.type + 'TariffZonesTableFields', JSON.stringify(val))
  }

  @Watch('tariffTypeFilter', {deep: true})
  onTariffTypeFilterChange(val: any) {
    this.is_show_import = false;
    this.is_show_filter = false;
    sessionStorage.setItem(this.transport.toLowerCase() + this.type + 'TariffTypeFilter', JSON.stringify(val))
    let object = {
      partner_id: val.partner_id,
      operator_id: val.operator_id,
      transport: this.transport.toLowerCase()
    };
    this.actionGetItem(object)
        .then((data: TariffZoneGroupItem) => this.is_exist_tzg = !!data)
        .catch(() => this.is_exist_tzg = false)
    if ((this.type === this.partnerType && !val.partner_id) || (this.type === this.operatorType && !val.operator_id)) {
      this.is_show_filter = false;
    }
  }

  @Watch('tariffTypeFilter.partner_id')
  onPartnerIdChange(newVal: any, oldVal: any) {
    // При смене клиента - очистка компонента-импорта
    if (oldVal != undefined) {
      this.importComponent.resetData();
    }
  }

  getMessageCategoriesPrices(arr: any) {
    let message: string = ''
    arr.forEach((item: any) => {
      message += this.getMessageCategoriesByName(item.message_category_id) + ': ' + item.price + '<br/>';
    });
    return message;
  }

  getMessageCategoriesByName(id: any) {
    return this.messageCategoriesList.find((item: any) => item.id == id).name
  }

  get tableData(): TariffZoneItem[] {
    return this.tariffZonesResponse ? this.tariffZonesResponse : [];
  }

  get queriedData(): TariffZoneItem[] {
    return customSort<TariffZoneItem>(this.currentSort, this.currentSortOrder, this.tableData);
  }

  customSort(value: any): any {
    return customSort<TariffZoneItem>(this.currentSort, this.currentSortOrder, value);
  }
}
